import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {App} from 'ionic-angular';
import {OauthService} from './oauth.service';
import {Http} from '@angular/http';
import {ToolsService} from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class SiteService extends OauthService {


  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
  }

  getSites() {
    const url = this.Routing.generate('api_get_sites', {'_format': 'json'}, true);

    return this.http
      .get(`${url}`, {headers: this.updateHeaders()})
      .map(response => {
        return response.json().data;
      });
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/site.service.ts